<template>
  <div class="flex items-center" v-if="this.config?.dock?.DetId != 11">
    <!-- OnBatterie -->
    <svg v-if="!OnBatterie" class="fill-current w-[8px]" viewBox="0 0 36 88" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.684 36.92C35.315 36.347 34.681 36 34 36H22.234L25.987 2.22101C26.096 1.24501 25.48 0.335013 24.534 0.0730133C23.588 -0.188987 22.591 0.275013 22.181 1.16701L0.180998 49.167C-0.103002 49.786 -0.0519997 50.507 0.316 51.08C0.685 51.653 1.319 52 2 52H13.766L10.013 85.779C9.905 86.755 10.521 87.665 11.467 87.927C11.644 87.977 11.823 88 12 88C12.766 88 13.485 87.559 13.818 86.833L35.818 38.833C36.102 38.214 36.051 37.493 35.684 36.92Z" />
    </svg>

    <svg v-else class="w-5 fill-warning" viewBox="0 0 82 46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.299988 0.900024V45.1H71.1V34.5H81.7V11.5H71.1V0.900024H0.299988ZM65.1 39.1H6.29999V6.90003H65.1V39.1ZM75.7 17.5V28.5H71.1V17.5H75.7Z" />
      <path class="b1" d="M21.1 14H15.1V32.08H21.1V14Z" />
      <path class="b2" d="M38.2 14H32.2V32.08H38.2V14Z" />
      <path class="b3" d="M55.2 14H49.2V32.08H55.2V14Z" />
    </svg>

    <span class="ml-2" :class="PowerONColor">{{ PowerON }}</span>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    OnBatterie() {
      return this.config?.dock?.status?.electric_supply_voltage != undefined
        ? this.config.dock?.status.electric_supply_voltage < 50
        : true;
    },

    PowerON() {
      if (this.config?.dock?.status?.DetId == 11) {
        return this.config?.dock?.status?.electric_supply_voltage != undefined
          ? (this.config.dock.status.electric_supply_voltage / 100).toFixed(0) + ' V'
          : ENV.NO_DATA;
      }
      return this.config?.dock?.status?.electric_supply_voltage != undefined
        ? (this.config.dock.status.electric_supply_voltage).toFixed(0) + ' V'
        : ENV.NO_DATA;
    },

    PowerONColor() {
      let PowerON = this.config?.dock?.status?.electric_supply_voltage != undefined
        ? this.config.dock?.status.electric_supply_voltage < 50
        : true;

      return PowerON ? 'text-error' : '';
    }
  },
};
</script>
